export default {
  button: {
    en: 'What\'s a Premium Product?',
  },
  descFragrances: {
    en: `
      Scentbird offers super-luxe perfumes and colognes with amazing savings.
      Premium Fragrances cost an additional $5&nbsp;or&nbsp;$10, which you’ll see reflected on your account 
      - for both new & existing members.
    `,
  },
  descProducts: {
    en: `
      Scentbird offers a limited run of super-luxe full-size products with amazing savings. 
      Premium Products cost an additional $5, $10&nbsp;or&nbsp;$15, which you’ll see reflected on your 
      account - for both new & existing members.
    `,
  },
  bottomText: {
    en: 'This surcharge will be applied to all subscriptions, referrals, gift cards and offers on Scentbird.',
  },
}
